import InfiniteScroll from 'react-infinite-scroll-component'
import { chakra } from '@chakra-ui/react'

export const ChakraInfiniteScroll = chakra(InfiniteScroll as any, {
  shouldForwardProp: (prop) => true,
})